import userApi from "./userApi"

export async function getUserdetails() {
try {
    const response = await userApi.get('/user/all')
    return response.data
} catch (error) {
    return error
}
}

/* Bloquer / débloquer : l'erreur remonte à l'appelant (403 si l'appelant
   n'est pas administrateur), au lieu d'être renvoyée comme une réponse. */
export async function blockUser(userId: string, motif: string) {
  const response = await userApi.put(`/user/${userId}/block`, null, { params: { motif } });
  return response.data;
}

export async function unblockUser(userId: string) {
  const response = await userApi.put(`/user/${userId}/unblock`);
  return response.data;
}
/** Suppression d'un compte (tracée par user-service) ; l'erreur remonte. */
export async function supprimerCompte(userId: number | string) {
  const response = await userApi.delete(`/user/${userId}`);
  return response.data;
}

export async function updateStatus(userId: any, formData: any) {
    try {
      const response = await userApi.put(`/user/update/${userId}`, formData);

      return response.data;
    } catch (error) {
      return error;
    }
  }


  export async function getAlltokens() {
    try {
        const response = await userApi.get('/user/getall')
        return response.data
    } catch (error) {
        return error
    }
    }



  
/* Retraits (décision D2). Le serveur calcule les montants et applique les
   règles ; l'erreur remonte à l'appelant avec le message du serveur. */
export async function getFileRetraits() {
  const response = await userApi.get('/token/file');
  return Array.isArray(response.data) ? response.data : [];
}

export async function deciderRetrait(id: number, status: 'approved' | 'rejected', reason?: string) {
  const response = await userApi.put(`/token/status/${id}`, { status, reason });
  return response.data;
}

export async function marquerRetraitVerse(id: number, referenceWave: string) {
  const response = await userApi.put(`/token/${id}/versement`, { referenceWave });
  return response.data;
}

/* Versement automatique via Wave (vague 2) : le serveur appelle Wave avec sa
   propre clé, jamais le navigateur. Faux si aucune clé n'est configurée ou si
   la question échoue : seul le versement manuel est alors proposé. */
export async function waveDisponible(): Promise<boolean> {
  try {
    const response = await userApi.get('/token/wave/disponible');
    return response.data?.disponible === true;
  } catch {
    return false;
  }
}

/* Retrait approuvé → versé via Wave. Échec : 409 (pas de clé, statut) ou 502
   (Wave a refusé ou n'a pas répondu), message affichable dans { message }. */
export async function verserRetraitWave(id: number) {
  const response = await userApi.post(`/token/${id}/verser-wave`);
  return response.data;
}

/* Correction manuelle d'un solde (décision D6) : montant signé et motif obligatoires.
   `cle` est générée à l'ouverture du formulaire : un double clic ou une
   relance après une erreur réseau renvoie la même clé, et le serveur ne
   corrige qu'une fois. */
export async function corrigerSolde(userId: number | string, montantTips: number, motif: string, cle: string) {
  const response = await userApi.post(`/user/${userId}/correction`, { montantTips, motif, cle });
  return response.data;
}

/** Clé unique d'un formulaire (crypto.randomUUID si disponible). */
export function nouvelleCle(): string {
  const c: any = (globalThis as any).crypto;
  if (c && typeof c.randomUUID === "function") return c.randomUUID();
  return Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
}

/** Message d'erreur du serveur (texte, ou champ « message » d'un objet), ou le libellé de repli. */
export function messageServeur(e: any, repli: string): string {
  const d = e?.response?.data;
  if (typeof d === 'string' && d.trim() !== '') return d;
  if (d && typeof d.message === 'string' && d.message.trim() !== '') return d.message;
  return repli;
}

/* Push « nouveau concours » à tous les Spotters actifs (user-service,
   POST /send-notification/bonus). Le serveur compose le texte depuis le
   concours enregistré : seul l'identifiant part d'ici. Un échec répond en
   4xx/5xx avec un texte court en français, que messageServeur restitue. */
export interface BilanPushConcours {
  message: string
  envoyes: number
  echecs: number
  sansJeton: number
}

export async function envoyerPushConcours(bonusId: number): Promise<BilanPushConcours> {
  const response = await userApi.post('/send-notification/bonus', { bonusId });
  return response.data;
}
